var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHeart(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 61,
    height: 66,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M36.075 11.562s2.17-6.822 8.352-7.006c3.427-.102 6.957 1.346 8.93 4.144 2.454 3.479 2.54 8.349.606 12.143-1.688 3.312-4.667 5.756-7.672 7.94-4.78 3.472-9.863 6.559-14.275 10.49-4.412 3.931-8.195 8.88-9.446 14.662-5.828-6.895-10.265-13.86-13.107-21.79-1.46-4.074-2.185-8.48-1.543-12.76.402-2.685 1.444-5.433 3.602-7.077 1.82-1.387 4.238-1.813 6.513-1.571 3.103.33 5.933 1.833 8.17 3.978 2.392 2.293 3.492 5.011 5.04 7.821-.214-4.028-1.335-7.463-2.847-10.132-1.815-3.203-4.686-5.899-8.191-7.012-3.804-1.209-8.467-1.324-12.132.376-9.66 4.48-8.899 16.475-6.03 25.114 5.65 17.015 23.656 34.153 23.656 34.153.302-1.091.394-8.196 6.816-16.148 3.4-4.211 8.213-6.71 12.466-9.92 3.345-2.525 6.522-5.318 9.138-8.61 3.503-4.408 6.245-10.117 6.049-15.873-.175-5.107-2.952-10.086-7.647-12.298C48.449.267 43.233.09 39.148 3.65c-2.204 1.92-3.497 5.017-3.073 7.912"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h61v66H0z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeart);
export default __webpack_public_path__ + "static/media/heart.42d42660eebf6dbd98f4a2bb01221336.svg";
export { ForwardRef as ReactComponent };